/*
 * Module for the Insurance deduction corrections tab
*/
rs.module("content/participant/benefit/insurance/edit/deductioncorrections",

    [
        "controls/components/event-banner"
    ],

    function (eventBanner) {

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrl, columnIds, grid) {

            // Unpack js selectors
            var form = $.js(jsSelectors.form);

            var updateToken = form.js(jsSelectors.updateToken);
            var deductionCorrectionKey = form.js(jsSelectors.deductionCorrectionKey);
            var payeeDeductionAmountInput = form.js(jsSelectors.payeeDeductionAmountInput);
            var subsidyAmountInput = form.js(jsSelectors.subsidyAmountInput);
            var effectiveDateInput = form.js(jsSelectors.effectiveDateInput);
            var terminationDateInput = form.js(jsSelectors.terminationDateInput);
            var correctionReasonText = form.js(jsSelectors.correctionReasonText);
            var addCorrectionButton = form.js(jsSelectors.addCorrectionButton);
            var cancelCorrectionButton = form.js(jsSelectors.cancelCorrectionButton);

            // On add button click, clear the form
            addCorrectionButton.click(function () {

                eventBanner.removeAllMessages();
                grid.selectedValues = null;

                // Reset inputs
                [
                    updateToken,
                    payeeDeductionAmountInput,
                    subsidyAmountInput,
                    effectiveDateInput,
                    terminationDateInput,
                    correctionReasonText
                ].forEach((input) => input.clearErrors().val(''));

                deductionCorrectionKey.val(-1);

            });

            // On cancel button click, select first entry and clear event banner.
            cancelCorrectionButton.click(function () {

                // Reset inputs
                [
                    payeeDeductionAmountInput,
                    subsidyAmountInput,
                    effectiveDateInput,
                    terminationDateInput,
                    correctionReasonText
                ].forEach((input) => input.clearErrors().val(''));

                grid.selectedValues = null;
                grid.selectFirstRow();
                eventBanner.removeAllMessages();
            });

            // Listen for row selection 
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    $.getJSON(backendUrl, { deductionCorrectionKey: rows[0][columnIds.deductionCorrectionKey] }).done(function (data) {

                        // Hidden Token
                        updateToken.val(data.updateToken);
                        deductionCorrectionKey.val(data.deductionCorrectionKey);
                        payeeDeductionAmountInput.val(data.payeeDeductionAmount);
                        subsidyAmountInput.val(data.subsidyAmount);
                        effectiveDateInput.val(data.effectiveDate);
                        terminationDateInput.val(data.terminationDate);
                        correctionReasonText.val(data.correctionReason);

                        [
                            payeeDeductionAmountInput,
                            effectiveDateInput
                        ].forEach((input) => input.clearErrors());
                        eventBanner.removeAllMessages();
                    });
                }

                _executeSelectionChanged = true;
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);